import React from 'react';
import { connect } from 'react-redux';
import { getNodeSeriesStats, getParams, findOccupancyTag, findEfficiencyTag } from 'actions/stats';
import { RECEIVE_FIRST_LOCATION_RANGE, RECEIVE_SECOND_LOCATION_RANGE } from 'actions/comparison';
import RangeChart from 'components/common/charts/rangechart';
import ModeSelector from 'components/common/dropdowncomponents/modeselector';
import TagSelector from 'components/common/dropdowncomponents/tagselector';
//import Modal from "components/common/modal";

class RangeChartComparison extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: 'Average',
            tag: 'Occupancy'
        };
    }
    // chooseTag locally changes tag inside this component, so whenever querySettings change -> setState of the tag
    // Or when the location changes from meeting room to open area which doesn't have efficiency tag -> setState of the tag
    componentWillReceiveProps(nextProps) {
        if (nextProps.isMeetingRoom !== this.props.isMeetingRoom ||
            nextProps.querySettings != this.props.querySettings) {
            this.setState({
                tag: 'Occupancy'
            })
        }
    }
    chooseMode(mode) {
        this.setState({ mode: mode });
    }

    chooseTag(tag) {
        this.setState({ tag: tag });
        let params = getParams({ querySettings: this.props.querySettings, currentNode: this.props.first });
        params.action = RECEIVE_FIRST_LOCATION_RANGE;
        let params1 = getParams({ querySettings: this.props.querySettings, currentNode: this.props.second });
        params1.action = RECEIVE_SECOND_LOCATION_RANGE;
        params.groupby = "hour"
        params1.groupby = "hour"

        if (tag === 'Occupancy') {
            params.tag = findOccupancyTag(this.props.first);
            params1.tag = findOccupancyTag(this.props.second);
        }
        else {
            params.tag = findEfficiencyTag(this.props.first);
            params1.tag = findEfficiencyTag(this.props.second);
        }
        this.props.dispatch(getNodeSeriesStats(params));
        this.props.dispatch(getNodeSeriesStats(params1));
    }

    getValues(index) {
        let attribute = this.state.mode == 'Average' ? 'avg' : 'pk';
        let values = [0, 0, 0, 0, 0, 0, 0];
        this.props.stats[index].data.points.forEach((point) => {
            if (point[attribute] < 0.00001) {
                values[0] += 1;
                values[1] += 1;
            }
            else if (point[attribute] < 0.2) {
                values[1] += 1;
            }
            else if (point[attribute] < 0.4) {
                values[2] += 1;
            }
            else if (point[attribute] < 0.6) {
                values[3] += 1;
            }
            else if (point[attribute] < 0.8) {
                values[4] += 1;
            }
            else if (point[attribute] < 0.99999) {
                values[5] += 1;
            }
            else {
                values[5] += 1;
                values[6] += 1;
            }
        });
        return values;
    }


    render() {
        let values = [];
        let values1 = [];
        if (this.props.stats.length == 2 && this.props.stats[0] && this.props.stats[1]) {
            values = this.getValues(0);
            values1 = this.getValues(1);

        }

        return (
            <div className="stats-card">
                <div className="box--shadow bg--white card__graph">
                    <div className="clearfix graph__header">
                        <h2 className="graph__header__title graph__header__title--comparison-title pull-left">{this.state.tag} Range Comparison</h2>
                        <div className="graph__header__options pull-right clearfix">
                            <div className="header__options__child pull-left"><ModeSelector mode={this.state.mode} chooseMode={this.chooseMode.bind(this)} /></div>
                            {this.props.isMeetingRoom &&
                                <div className="header__options__child pull-left"><TagSelector roomType="meeting_room" tag={this.state.tag} chooseTag={this.chooseTag.bind(this)} /></div>
                            }
                            {/*    <Modal
                                disableCloseButton={true}
                                ref={(elem) => { this.openInfoModal = elem }}
                                clickButton={() => { this.openInfoModal.close(); }}
                                header="Info Modal"
                                buttonText="Got it"
                                buttonClass="btn-success"
                                entry={
                                    <div className="header__options__child pull-left">
                                        <div onClick={() => { this.openInfoModal.open() }} className="">
                                            <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                        </div>
                                    </div>
                                }
                            >
                                <p>Range Comparison Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                            </Modal>*/}
                        </div>
                    </div>
                    <div className="graph__body">
                        <RangeChart id="rangecomparisonchart" values={values} values1={values1} />
                    </div>
                    <div className="graph__body-legend-wrapper">
                        <div className="legend__location flex--center pull-left">
                            <div className="legend__location__square legend__location__square--blue  pull-left"></div>
                            <div className="legend__location__name pull-left">{this.props.first.info ? this.props.first.info.name : 'Location 1'} </div>
                        </div>
                        <div className="legend__location flex--center pull-left">
                            <div className="legend__location__square legend__location__square--green  pull-left"></div>
                            <div className="legend__location__name pull-left">{this.props.second.info ? this.props.second.info.name : 'Location 2'}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(null, mapDispatchToProps)(RangeChartComparison);


// WEBPACK FOOTER //
// ./src/components/pages/comparison/charts/rangechart/index.jsx